import { combineReducers } from 'redux';

import profile from './profile/reducer';
import passwordUpdate from './passwordUpdate/reducer';
import avatars from './avatars/reducer';
import avatarSelection from './avatarSelection/reducer';

export default combineReducers({
  profile,
  passwordUpdate,
  avatars,
  avatarSelection
});




/** WEBPACK FOOTER **
 ** ./src/members/state/user/reducer.js
 **/